// merchant -> category
export default
[
    {
      "merchant":"amazon",
      "category":"shopping",
    },
    {
        "merchant":"village toys",
        "category":"shopping",
    },
    {
        "merchant":"clock tower shop",
        "category":"music",
    },
    {
        "merchant":"Books Inc.",
        "category":"shopping",
    },
    {
        "merchant":"Pepboys",
        "category":"auto",
    },
    {
        "merchant":"Raley's",
        "category":"groceries",
    },
    {
        "merchant":"HP",
        "category":"shopping",
    },
    {
        "merchant":"fastrak",
        "category":"tolls",
    },
    {
        "merchant":"bean scene cafe",
        "category":"coffee_shop",
    },
    {
        "merchant":"tamari georgian restaurant",
        "category":"restaurants",
    },
    {
        "merchant":"the home depot",
        "category":"shopping",
    },
    {
        "merchant":"anthropologie",
        "category":"clothing",
    },
    {
        "merchant":"lake tahoe oil company",
        "category":"gas",
    },
    {
        "merchant":"mademoiselle colette",
        "category":"coffee_shop",
    },
    {
        "merchant":"kiwico",
        "category":"kids",
    },
    {
        "merchant":"cafe borrone",
        "category":"coffee_shop",
    },
    {
        "merchant":"bagel street cafe",
        "category":"coffee_shop",
    },
    {
        "merchant":"red giant coffee",
        "category":"coffee_shop",
      },
    {
        "merchant":"kraft music",
        "category":"shopping",
    },
    {
        "merchant":"iherb.com",
        "category":"shopping",
    },
    {
        "merchant":"bz bee market",
        "category":"groceries",
    },
    {
        "merchant":"edgewood tahoe lodge",
        "category":"hotel",
    },
    {
        "merchant":"oil changer",
        "category":"car_maintenance",
    },
    {
      "merchant":"target",
      "category":"shopping"
    },
    {
      "merchant":"Minamoto Kitchoan",
      "category":"shopping"
    },
    {
      "merchant":"Cranberry Scoop",
      "category":"shopping"
    },
    {
      "merchant":"Daiso",
      "category":"shopping"
    },
    {
      "merchant":"terrain.com",
      "category":"shopping"
    },
    {
      "merchant":"the sill",
      "category":"shopping"
    },
    {
      "merchant":"apple",
      "category":"shopping"
    },
    {
      "merchant":"nespresso",
      "category":"shopping"
    },
    {
      "merchant":"uber trip",
      "category":"taxi"
    },
    {
      "merchant":"Lyft",
      "category":"taxi"
    },
    {
      "merchant":"uber eats",
      "category":"restaurants"
    },
    {
      "merchant":"The Crepe Stop",
      "category":"restaurants"
    },
    {
      "merchant":"Lakeside Cafe",
      "category":"restaurants"
    },
    {
      "merchant":"Onigilly",
      "category":"restaurants"
    },
    {
      "merchant":"Bumble",
      "category":"restaurants"
    },
    {
      "merchant":"New Mongolian BBQ",
      "category":"restaurants"
    },
    {
      "merchant":"Oren's Hummus",
      "category":"restaurants"
    },
    {
      "merchant":"Sajj",
      "category":"restaurants"
    },
    {
      "merchant":"masa sushi",
      "category":"restaurants"
    },
    {
      "merchant":"zpizza",
      "category":"restaurants"
    },
    {
      "merchant":"bevri",
      "category":"restaurants"
    },
    {
      "merchant":"amazon kindle",
      "category":"books"
    },
    {
      "merchant":"kindle unlimited",
      "category":"subscription"
    },
    {
      "merchant":"amazon prime",
      "category":"subscription"
    },
    {
      "merchant":"prime video",
      "category":"movies"
    },
    {
      "merchant":"Victoria's Secret",
      "category":"clothing"
    },
    {
      "merchant":"MaxMara",
      "category":"clothing"
    },
    {
      "merchant":"Gap",
      "category":"clothing"
    },
    {
      "merchant":"H&M",
      "category":"clothing"
    },
    {
      "merchant":"everlane",
      "category":"clothing"
    },
    {
      "merchant":"lucky brand",
      "category":"clothing"
    },
    {
      "merchant":"j.crew",
      "category":"clothing"
    },
    {
      "merchant":"jenni kane",
      "category":"clothing"
    },
    {
      "merchant":"anthropologie",
      "category":"clothing"
    },
    {
      "merchant":"100 Percent Pure",
      "category":"cosmetics"
    },
    {
      "merchant":"Lush Cosmetics",
      "category":"cosmetics"
    },
    {
      "merchant":"Arby's",
      "category":"fast_food"
    },
    {
      "merchant":"Sugarfina",
      "category":"food"
    },
    {
      "merchant":"Coffee Bean",
      "category":"coffee_shop"
    },
    {
      "merchant":"Adorable Bakery",
      "category":"coffee_shop"
    },
    {
      "merchant":"Manresa Bread",
      "category":"coffee_shop"
    },
    {
      "merchant":"Peet's Coffee",
      "category":"coffee_shop"
    },
    {
      "merchant":"Cafe Venetia",
      "category":"coffee_shop"
    },
    {
      "merchant":"Little Sky Bakery",
      "category":"coffee_shop"
    },
    {
      "merchant":"The Prolific Oven",
      "category":"coffee_shop"
    },
    {
      "merchant":"Blue Bottle Coffee",
      "category":"coffee_shop"
    },
    {
      "merchant":"Coffee & More",
      "category":"coffee_shop"
    },
    {
      "merchant":"Paris Baguette",
      "category":"coffee_shop"
    },
    {
      "merchant":"starbucks",
      "category":"coffee_shop"
    },
    {
      "merchant":"alexander's patisserie",
      "category":"coffee_shop"
    },
    {
      "merchant":"maison alyzee",
      "category":"coffee_shop"
    },
    {
      "merchant":"joe and the juice",
      "category":"coffee_shop"
    },
    {
      "merchant":"la baguette",
      "category":"coffee_shop"
    },
    {
      "merchant":"philz coffee",
      "category":"coffee_shop"
    },
    {
      "merchant":"Specialty's Caf\u00e9 & Bakery",
      "category":"coffee_shop"
    },
    {
      "merchant":"coupa cafe",
      "category":"coffee_shop"
    },
    {
      "merchant":"Diddams",
      "category":"gifts"
    },
    {
      "merchant":"Taste Nutrition",
      "category":"school_food"
    },
    {
      "merchant":"East Bay Regional Park District",
      "category":"parks"
    },
    {
      "merchant":"MTS.ru",
      "category":"phone"
    },
    {
      "merchant":"Google Voice",
      "category":"phone"
    },
    {
      "merchant":"Google Youtube",
      "category":"movies"
    },
    {
      "merchant":"Google Drive",
      "category":"bill_utilities"
    },
    {
      "merchant":"Skillshare",
      "category":"education"
    },
    {
      "merchant":"REI",
      "category":"sport_outdoor_shopping"
    },
    {
      "merchant":"the north face",
      "category":"sport_outdoor_shopping"
    },
    {
      "merchant":"cognition cyclery",
      "category":"sport_outdoor_shopping"
    },
    {
      "merchant":"Lucky Supermarket",
      "category":"groceries"
    },
    {
      "merchant":"Ava's downtown market",
      "category":"groceries"
    },
    {
      "merchant":"Felipe's Market",
      "category":"groceries"
    },
    {
      "merchant":"Whole Foods",
      "category":"groceries"
    },
    {
      "merchant":"Bianchinis Market",
      "category":"groceries"
    },
    {
      "merchant":"nob hill",
      "category":"groceries"
    },
    {
      "merchant":"99 ranch market",
      "category":"groceries"
    },
    {
      "merchant":"marukai market",
      "category":"groceries"
    },
    {
      "merchant":"Instacart",
      "category":"groceries"
    },
    {
      "merchant":"trader joe's",
      "category":"groceries"
    },
    {
      "merchant":"safeway",
      "category":"groceries"
    },
    {
      "merchant":"Chevron",
      "category":"gas"
    },
    {
      "merchant":"76",
      "category":"gas"
    },
    {
      "merchant":"shell",
      "category":"gas"
    },
    {
      "merchant":"Southwest Airlines",
      "category":"air_travel"
    },
    {
      "merchant":"Delta Airlines",
      "category":"air_travel"
    },
    {
      "merchant":"Alaska Airlines",
      "category":"air_travel"
    },
    {
      "merchant":"juut",
      "category":"hair"
    },
    {
      "merchant":"Palo Alto Medical Foundation",
      "category":"doctor"
    },
    {
      "merchant":"ikea",
      "category":"furniture"
    },
    {
      "merchant":"walgreens",
      "category":"pharmacy"
    },
    {
      "merchant":"anima pro",
      "category":"business"
    },
    {
      "merchant":"Beard Papa",
      "category":"coffee_shop"
    },
    {
      "merchant":"Janie and Jack",
      "category":"clothing"
    },
    {
      "merchant":"eileen fisher",
      "category":"clothing"
    },
    {
      "merchant":"le boulanger",
      "category":"coffee_shop"
    },
    {
      "merchant":"onsite haircuts",
      "category":"hair"
    },
    {
      "merchant":"grocery outlet",
      "category":"groceries"
    },
    {
      "merchant":"cvs pharmacy",
      "category":"pharmacy"
    },
    {
      "merchant":"camino pharmacy",
      "category":"pharmacy"
    },
    {
      "merchant":"learning express toys",
      "category":"toys"
    },
    {
      "merchant":"Wealthfront",
      "category":"transfer"
    },
    {
      "merchant":"Chase",
      "category":"transfer"
    },
    {
      "merchant":"Chase",
      "category":"transfer"
    },
    {
      "merchant": "Bank Of America",
      "category":"transfer"
    },
    {
      "merchant": "Souzan",
      "category": "daycare_preschool"
    },
    {
      "merchant": "PG & E",
      "category": "bills_utilities"
    },
    {
      "merchant": "verizon",
      "category": "bills_utilities",
    },
    {
      "merchant": "kindercare",
      "category": "daycare_preschool",
    },
    {
      "merchant": "fidelity",
      "category": "transfer",
    },
    {
      "merchant": "porkbun",
      "category": "bills_utilities",
    },
    {
      "merchant": "comcast",
      "category": "bills_utilities",
    },
    {
      "merchant": "venmo",
      "category": "transfer",
    },
    {
      "merchant": "jcrew",
      "category": "clothing"
    },
    {
      "merchant": "patagonia",
      "category": "clothing"
    },
    {
      "merchant": "backcountry",
      "category": "clothing"
    },
    {
      "merchant": "goop",
      "category": "shopping"
    },
    {
      "merchant": "reima",
      "category": "clothing"
    },
    {
      "merchant": "zara",
      "category": "clothing"
    },
    {
      "merchant": "mother llc",
      "category": "clothing"
    },
    {
      "merchant": "nordstrom",
      "category": "clothing"
    },
    {
      "merchant": "burton",
      "category": "clothing"
    },
    {
      "merchant": "doordash",
      "category": "restaurants"
    },
    {
      "merchant": "chanel",
      "category": "shopping"
    },
    {
      "merchant": "columbia sport",
      "category": "clothing"
    },
    {
      "merchant": "lulus fashion",
      "category": "clothing"
    },
    {
      "merchant": "urban outfitters",
      "category": "clothing"
    },
    {
      "merchant": "ecoalf recycled",
      "category": "clothing"
    },
    {
      "merchant": "Kiel James Patrick",
      "category": "clothing"
    },
    {
      "merchant": "HauteLook",
      "category": "clothing"
    },
    {
      "merchant": "Young, Wild and Freedman",
      "category": "kids"
    },
    {
      "merchant": "UGG",
      "category": "clothing"
    }
  ]